export const uiThemes = {
  classic: {
    bg: "white",
    text: "#1a202c",
    primary: "#4285F4",
    accent: "#63b3ed",
  },
  dark: {
    bg: "#1a202c",
    text: "#e2e8f0",
    primary: "#718096",
    accent: "#4fd1c5",
  },
  plain: {
    bg: "#f7fafc",
    text: "#2d3748",
    primary: "#2b6cb0",
    accent: "#a0aec0",
  },
  neon: {
    bg: "#0e1626",
    text: "#8ec3b9",
    primary: "#74c0fc",
    accent: "#38b2ac",
  },
};
